/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Správce virtuální klávesnice pro standardní webové technologie.
 * Předpokládá se, že web platforma virtuální klávesnici nevyvolá.
 * @implements {VirtualKeyboardManager}
 * @memberof AdapterWeb
 */
class VirtualKeyboardManager {
  /**
   * @param {VirtualKeyboardHiddenFactory} factory
   */
  constructor(factory) {
    this.factory = factory;
  }

  /** @inheritdoc */
  destroy() {
    // Prázdná metoda pro splnění rozhraní.
  }

  /** @inheritdoc */
  getInfo() {
    return new Promise((resolve) => resolve(this.factory.create()));
  }

  /** @inheritdoc */
  on(type, callback) {
    // Prázdná metoda pro splnění rozhraní.
  }

  /** @inheritdoc */
  off(type, callback) {
    // Prázdná metoda pro splnění rozhraní.
  }
}

export default VirtualKeyboardManager;
